/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react"

// react-router-dom components
import { Link, useNavigate } from "react-router-dom"

// @mui material components
import Card from "@mui/material/Card"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDInput from "components/MDInput"
import MDButton from "components/MDButton"

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout"

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg"
import { Controller, useForm } from "react-hook-form"
import MDSnackbar from "components/MDSnackbar"

// Services
import * as patterns from "../../../utils/constants/patterns"
import * as authService from "../../../services/auth/auth.service"

function Basic() {
  const navigate = useNavigate()
  const { control, handleSubmit } = useForm()
  const [snackbarObject, setSnackbarObject] = useState({
    open: false,
    title: "",
    content: "",
    color: "primary",
    icon: "",
  })

  // Handle create new package
  const login = async (body) => {
    // setIsLoading(true)
    try {
      const result = await authService.loginService(body)
      if (result) {
        if (result.response && result.response.data) {
          if (result.response.data.status === 400) {
            handleOpenSnackbar(
              "error",
              "Erreur d'authentification",
              "Merci de vérifier l'email ou la mot de passe",
              "error"
            )
          }
        }
        if (result.data && result.data.status === 200) {
          localStorage.setItem("resuxi-token", result.data.accesToken)
          navigate("/colis")
          // location.reload()
        }
      }
    } catch (error) {
      handleOpenSnackbar("error", "Erreur du serveur", "Merci de réessayez autre fois", "error")
    }
  }

  // Handle open snackbar
  const handleOpenSnackbar = (status, title, content, icon) => {
    setSnackbarObject({
      ...snackbarObject,
      title,
      open: true,
      content,
      color: status,
      icon,
    })
  }

  // Handle close snackbar
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    setSnackbarObject({
      ...snackbarObject,
      open: false,
    })
  }

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" mx={2} mt={-3} p={2} mb={1}>
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Se Connecter
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox
            component="form"
            role="form"
            onSubmit={handleSubmit(login)}
            textAlign="center"
            noValidate
            autoComplete="off"
          >
            <MDBox mb={2}>
              <Controller
                control={control}
                name="email"
                defaultValue=""
                rules={{
                  required: {
                    value: true,
                    message: "Le champ email est obligatoire",
                  },
                  pattern: {
                    value: patterns.regExpEmail,
                    message: "Le champ email doit inclure '@' et '.'",
                  },
                }}
                render={({ field: { ref, ...field }, fieldState: { error } }) => (
                  <MDInput
                    type="email"
                    label="Email"
                    fullWidth
                    error={Boolean(error)}
                    focused={Boolean(error)}
                    helperText={error && error.message}
                    {...field}
                  />
                )}
              />
            </MDBox>
            <MDBox mb={2}>
              <Controller
                control={control}
                name="password"
                defaultValue=""
                rules={{
                  required: {
                    value: true,
                    message: "Le champ mot de passe est obligatoire",
                  },
                }}
                render={({ field: { ref, ...field }, fieldState: { error } }) => (
                  <MDInput
                    type="password"
                    label="Mot De Passe"
                    fullWidth
                    error={Boolean(error)}
                    focused={Boolean(error)}
                    helperText={error && error.message}
                    {...field}
                  />
                )}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth>
                Connecter
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Mot De Passe Oublié?{" "}
                <MDTypography
                  component={Link}
                  to="/forget-password"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                  onClick={() => navigate("/forget-password")}
                >
                  Réinitialiser Le Mot De Passe
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <MDSnackbar
        color={snackbarObject.color}
        icon={snackbarObject.icon}
        title={snackbarObject.title}
        content={snackbarObject.content}
        open={snackbarObject.open}
        close={handleCloseSnackbar}
        dateTime=""
      />
    </BasicLayout>
  )
}

export default Basic
